import React from 'react';
import { Typography, CardContent, Paper, Stack, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import book1 from '../../assets/book1.webp';
import book2 from '../../assets/kennedytheairflow_An_underground_cartoon_tunnel_system_sprawlin (1).png';

const useStyles = makeStyles({
  '@global': {
    '*': {
      fontFamily: "'Chewy', cursive !important", // Apply globally
      margin: 0,
      padding: 0,
    },
  },
  root: {
    padding: '20px',
  },
  header: {
    marginBottom: '32px',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 'bold ! important',
    color: 'rgb(95, 58, 25)',
    marginBottom: '8px',
    fontFamily: "'Chewy', cursive !important",
    // Specific use case
  },
  subtitle: {
    fontSize: '1rem',
    color: 'rgb(104, 88, 67)',

    fontFamily: "'Chewy', cursive !important",
  },
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '16px',
  },

  card: {
    flex: '1 1 550px', // Default width for larger screens
    minWidth: '300px',
    display: 'flex',
    backgroundColor: '#E4D2BA !important',

    flexDirection: 'column',
  },
  authorHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '8px',
    marginBottom: '16px',
    color: 'rgb(95, 58, 25)',
  },

  year: {
    backgroundColor: 'rgb(104, 88, 67)',
    color: '#E4D2BA ! important',
    padding: '4px 8px',
    borderRadius: '50px',
  },
  quoteBox: {
    backgroundColor: '#D2B48C ! important',
    padding: '10px',
    marginBottom: '16px',
    borderLeft: '4px solid rgb(95, 58, 25)',
    borderRadius: '4px',
  },

  quotes: {
    fontSize: '16px',
    color: 'rgb(104, 88, 67)',
  },
  significance: {
    marginTop: '8px',
    color: 'rgb(95, 58, 25)',
    '& span': {
      fontWeight: 'bold',
    },
  },
  contributionsTitle: {
    marginBottom: '16px',
    color: 'rgb(95, 58, 25)',
  },
  contribution: {
    backgroundColor: '#D2B48C !important',
    color: 'rgb(104, 88, 67) !important',
    padding: '16px',
    marginBottom: '8px',
    borderRadius: '4px',
  },

  imageCont: { objectFit: 'cover' },
});

const academicData = {
  title: 'ACADEMIC FOUNDATION',
  subtitle:
    'Exploring the academic foundations and theoretical framework of memes, from their initial conception to modern understanding.',
  authors: [
    {
      name: 'Richard Dawkins',
      year: 1976,
      image: book1,
      quote: {
        text: 'A meme is a unit of cultural transmission, analogous to a gene, that replicates itself as it spreads from mind to mind.',
        significance: 'First formal definition of memes',
      },
      keyContributions: [
        "Coined the term 'meme'",
        'Established memetics as a field',
        'Created framework for understanding cultural evolution',
      ],
    },
    {
      name: 'Susan Blackmore',
      year: 1999,
      image: book2,
      quote: {
        text: 'Memes are stories, songs, habits, skills, inventions, and ways of doing things that we copy from person to person by imitation',
        significance: 'Modern interpretation of meme concept',
      },
      keyContributions: [
        'Extended meme theory to consciousness',
        'Developed concept of memetic drive',
        'Explored relationship between memes and technology',
      ],
    },
  ],
};

function AcademicFoundation() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Box
        className={classes.header}
        sx={{
          padding: {
            lg: '0px 5.5rem ',
            md: 5,
            sm: 5,
            xs: '30px 4px',
          },
        }}
      >
        <Typography
          variant="h4"
          className={classes.title}
          sx={{
            fontSize: {
              lg: '2rem ',
              md: '2rem',
              sm: '1.5rem',
              xs: '1.5rem',
            },
          }}
        >
          {academicData.title}
        </Typography>
        <Typography variant="h6" className={classes.subtitle}>
          {academicData.subtitle}
        </Typography>
      </Box>
      <div className={classes.flexContainer}>
        {academicData.authors.map((author, index) => (
          <Box
            key={index}
            className={classes.card}
            sx={{
              maxWidth: {
                lg: '700px',
                md: '700px',
              },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                paddingLeft: {
                  lg: '19px',
                  md: '19px',
                },
                justifyContent: {
                  lg: 'flex-start',
                  md: 'flex-start',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <img
                component="img"
                height="400"
                width="300"
                src={author.image}
                alt={`Cover of ${author.name}'s book`}
                className={classes.imageCont}
              />
            </Box>

            <CardContent>
              <div className={classes.authorHeader}>
                <Typography variant="h5">{author.name}</Typography>
                <Typography className={classes.year}>{author.year}</Typography>
              </div>
              <Paper elevation={0} className={classes.quoteBox}>
                <Typography variant="body1" className={classes.quotes}>
                  {author.quote.text}
                </Typography>
              </Paper>
              <Typography variant="body2" className={classes.significance}>
                <span>Significance: </span>
                <span style={{ color: 'rgb(104, 88, 67)' }}>
                  {' '}
                  {author.quote.significance}
                </span>
              </Typography>
              <Stack spacing={2} pt={4}>
                <Typography
                  variant="body"
                  className={classes.contributionsTitle}
                >
                  Key Contributions:
                </Typography>
                {author.keyContributions.map((contribution, index) => (
                  <Paper key={index} className={classes.contribution}>
                    <Typography>{contribution}</Typography>
                  </Paper>
                ))}
              </Stack>
            </CardContent>
          </Box>
        ))}
      </div>
    </div>
  );
}

export default AcademicFoundation;
